"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LdoFactory = void 0;
var o_dataset_pack_1 = require("o-dataset-pack");
var createLinkedDataObject_1 = require("./createLinkedDataObject");
var jsonld_dataset_proxy_1 = __importDefault(require("jsonld-dataset-proxy"));
var data_model_1 = __importDefault(require("@rdfjs/data-model"));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var LdoFactory = /** @class */ (function () {
    function LdoFactory(shapeType) {
        this.shapeType = shapeType;
    }
    LdoFactory.prototype.parse = function (id, data, options) {
        return __awaiter(this, void 0, void 0, function () {
            var dataset, entryNode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof data === "string")) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, o_dataset_pack_1.serializedToSubscribableDataset)(data, options)];
                    case 1:
                        // Input data is serialized
                        dataset = _a.sent();
                        return [3 /*break*/, 5];
                    case 2:
                        if (!(typeof data.add === "function")) return [3 /*break*/, 3];
                        // Input data is a dataset
                        dataset = (0, o_dataset_pack_1.createSubscribableDataset)(data);
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, (0, o_dataset_pack_1.serializedToSubscribableDataset)(JSON.stringify(data), {
                            format: "application/json-ld",
                        })];
                    case 4:
                        dataset = _a.sent();
                        _a.label = 5;
                    case 5:
                        entryNode = typeof id === "string" ? data_model_1.default.namedNode(id) : id;
                        return [2 /*return*/, (0, createLinkedDataObject_1.createLinkedDataObject)(dataset.startTransaction(), entryNode, this.shapeType)];
                }
            });
        });
    };
    LdoFactory.prototype.new = function (id) {
        var entryNode = typeof id === "string" ? data_model_1.default.namedNode(id) : id || data_model_1.default.blankNode();
        var dataset = (0, o_dataset_pack_1.createSubscribableDataset)();
        return (0, createLinkedDataObject_1.createLinkedDataObject)(dataset.startTransaction(), entryNode, this.shapeType);
    };
    LdoFactory.prototype.fromJson = function (inputData) {
        var dataset = (0, o_dataset_pack_1.createSubscribableDataset)();
        var entryNode = inputData["@id"]
            ? data_model_1.default.namedNode(inputData["@id"])
            : data_model_1.default.blankNode();
        var proxy = (0, jsonld_dataset_proxy_1.default)(dataset, this.shapeType.context, entryNode);
        Object.entries(inputData).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            proxy[key] = value;
        });
        return (0, createLinkedDataObject_1.createLinkedDataObject)(dataset.startTransaction(), entryNode, this.shapeType);
    };
    return LdoFactory;
}());
exports.LdoFactory = LdoFactory;
